module.exports = __webpack_public_path__ + "static/img/qualifications_row_4.aaf02e4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about_company/qualifications/qualifications_row_4.png
// module id = kuo4
// module chunks = 1